import React from 'react';
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import type { QueryClientProviderProps, QueryKey } from 'react-query';
import { mapResponseToError } from 'utils/common';
import tracking from 'utils/tracking';

export const client = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta && query.meta.errorMessage) {
        tracking.errorV2(`${query.meta.errorMessage}: ${mapResponseToError(error)}`, error, {
          tags: query.meta.tags || [],
          ...query.meta
        });
      }
    }
  })
});

export const updateReactQueryCache = (key: QueryKey, data: unknown) => {
  client.setQueryData(key, data);
};

export const invalidateReactQueryCache = (key: QueryKey) => {
  client.invalidateQueries(key);
};

export const getAllQueryKeys = () => {
  return client
    .getQueryCache()
    .getAll()
    .map(query => query.queryKey);
};

export default (props: Omit<QueryClientProviderProps, 'client'>): JSX.Element => (
  <QueryClientProvider {...{ ...props, client }} />
);
